export enum FormValidationError {
    REQUIRED = 'REQUIRED',
    INSUFFICIENT_LENGTH = 'INSUFFICIENT_LENGTH',
    EXCEEDS_MAX_LENGTH = 'EXCEEDS_MAX_LENGTH',
    REGEX_PATTERN = 'REGEX_PATTERN',
    INSUFFICIENT_VALUE = 'INSUFFICIENT_VALUE',
    EXCEEDS_MAX_VALUE = 'EXCEEDS_MAX_VALUE',
    INSUFFICIENT_CHOICES = 'INSUFFICIENT_CHOICES',
    EXCEEDS_MAX_CHOICES = 'EXCEEDS_MAX_CHOICES'
}
